<template>
  <q-page padding class="docs-table">
    <settingsDlg  
      :showDlg = "settingsDlgVisible"
      :uuid = "uuid"
      :device_type = "device_type"
      v-on:closeSettingsDlg = "settingsDlgVisible = false" 
    />

    <selectPatientDlg  
      :showDlg = "selectPatientDlgVisible"
      :uuid = "uuid"
      v-on:closeSelectPatientDlg = "selectPatientDlgVisible = false; refresh()" 
    />

    <logDlg  
      :showDlg = "logDlgVisible"
      :uuid = "uuid"
      v-on:closeLogsDlg = "logDlgVisible = false" 
    />


    <q-table
      :title="$t('devicestitle')"
      color="primary"
      :data="serverData"
      :columns="columns"
      row-key="uuid"
      @request="request"
      :loading="loading"
      :pagination.sync="serverPagination"
    >
      <template slot="top-right" slot-scope="props">
        <q-btn color="primary" flat round icon="autorenew" :title="$t('refresh')" @click="refresh" :loading="loading" :key="props.uuid">
          <span slot="loading">
            <q-spinner-hourglass />
          </span>
        </q-btn>
      </template>



      <template slot="body" slot-scope="props">
        <q-tr :props="props" >

          <!-- Статус -->
          <q-td key="is_online" :props="props">
            <div class="row items-center no-wrap justify-around">
              <template v-if="props.row.is_online">
                <q-icon name="power" color = "primary" size="18pt" :title="$t('is_online')"/>
              </template>
              <template v-else>
                <q-icon name="power_off" color = "orange" size="18pt" :title="$t('is_online')"/>
              </template>
            </div>
          </q-td>

          <!-- Код устройства -->
          <q-td key="uuid" :props="props">
            <div class="row items-center">  
              <table class="first"> 
                <tr>
                  <td class="no_border">
                    {{ props.row.uuid }} <br>
                    <small>FW: {{ props.row.fw_device }} {{ props.row.fw_net }}</small>                    
                  </td>
                </tr>
              </table>
            </div>
          </q-td>

          <!-- Серийный номер -->
          <q-td key="serial" :props="props">
            <div class="row items-center no-wrap justify-around">
              <template v-if="props.row.serial !== null">
                {{ props.row.serial }}
              </template>
              <template v-else>
                {{ $t('missing')}}
              </template>
              <q-btn size="sm" round dense color="primary" icon="edit" class="q-ma-sm">
              <q-popup-edit v-model="edit_value" buttons persistent  @save="set_serial(props.row.uuid, edit_value)" @show="edit_value = props.row.serial">
                <q-input v-model="edit_value" />
              </q-popup-edit>
              </q-btn>
            </div>
          </q-td>

          <!-- Тип прибора -->
          <q-td key="type" :props="props">
            <template v-if="props.row.type=='osteon'">
              <img src="../assets/osteon_logo_invert.png" height="16px"/>
            </template>
          </q-td>

          <!-- Пациент -->
          <q-td key="patient" :props="props">
            <div class="row items-center justify-end no-wrap">            
              <template v-if="props.row.patient_name">
                  <div>{{ props.row.patient_name }}</div>
                  <q-btn size="sm" round dense color="primary" icon="remove" class="q-ma-xs" @click="unsetuser(props.row.uuid)"/>                
              </template>
                <template v-else>
                  <div>{{$t('notset')}}</div>                  
                  <q-btn size="sm" round dense :title="$t('addpatient')" icon = "add" class="q-ma-xs" color="primary"  @click="uuid=props.row.uuid; selectPatientDlgVisible=true;"/>
                </template>
              </div>
          </q-td>

          <!-- Дата регистрации прибора -->
          <q-td key="created" :props="props">
            {{ props.row.created | dateformat }}
          </q-td>

          <!-- Дата последней активности прибора -->
          <q-td key="last_activity" :props="props">
            {{ props.row.last_activity | datetimeformat }}
          </q-td>

          <!-- Настройка -->
          <q-td key="settings" :props="props">
            <q-btn size="md" glossy :title="$t('settingsbtn')" icon = "settings" color = "primary" @click="uuid=props.row.uuid; device_type=props.row.type; settingsDlgVisible=true;"/>
          </q-td>

          <!-- Состояние -->
          <q-td key="state" :props="props">
            {{$t('course')}}: {{ props.row.state?props.row.state.state_row:'-' }},
            {{$t('rest')}}: {{ props.row.state?props.row.state.state_count:'-' }}
          </q-td>

          <!-- Журнал -->
          <q-td key="log" :props="props">
              <q-btn size="md" glossy :title="$t('log')" icon = "format_list_numbered" color = "primary" @click="uuid=props.row.uuid; logDlgVisible=true;" />
          </q-td>

        </q-tr>
      </template>
    </q-table>
  </q-page>
</template>

<script>
import axios from 'axios'
import settingsDlg from '../components/SettingDevice.vue'
import selectPatientDlg from '../components/SelectPatient.vue'
import logDlg from '../components/LogDevice.vue'

export default {
  data () {
    return {
      serverData: [],
      serverPagination: {
         page: 1, rowsNumber: 10, rowsPerPage: 10 
      },  
      columns: [
        { name: 'is_online', label: this.$t('columns.is_online'), field: 'type', align: 'center', sortable: true },
        { name: 'uuid', label: this.$t('columns.uuid'), field: 'uuid', align: 'left', required:true, sortable: true },
        { name: 'serial', label: this.$t('columns.serial'), field: 'serial', align: 'left', sortable: true, classes: 'serial' },
        { name: 'type', label: this.$t('columns.devtype'), field: 'type', align: 'center', sortable: true },
        { name: 'patient', label: this.$t('columns.pacient'), field: 'patient', align: 'center', sortable: true },
        { name: 'created', label: this.$t('columns.regdate'), field: 'created', align: 'center', sortable: true },
        { name: 'last_activity', label: this.$t('columns.lastdate'), field: 'last_activity', align: 'center', sortable: true },
        { name: 'settings', label: this.$t('columns.settings'), field: 'settings', align: 'center', sortable: false },
        { name: 'state', label: this.$t('columns.stat'), field: 'state', align: 'center', sortable: false },
        { name: 'log', label: this.$t('columns.log'), field: 'log', align: 'center', sortable: false },

      ],
      loading: false,

      // ID таймера
      refreshid:0,
      // uuid выбранного продукта (используется для передачи в диалоговые окна)
      uuid: '',
      device_type: '',
      settingsDlgVisible: false,
      selectPatientDlgVisible: false,
      logDlgVisible: false,
      edit_value: ''
    }

  },

  methods: {

    set_serial: function(uuid, value) {
      let request = {
        serial: value
      }
      const requestStr = JSON.stringify(request)
      axios
        .post(`${this.$root.api_url}device/${uuid}/set_serial/`, requestStr, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then(() => {
        this.$q.notify({
            message: this.$t('serialsetsuccess'),
            type: 'positive',
            icon: 'thumb_up'
        })
        this.refresh()
        this.edit_value = ''
      })
      .catch((e) => {
          // eslint-disable-next-line
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('errors.serialchange'), type: 'negative', icon: 'report_problem' }); break
          }
      })
    },

    unsetuser: function(uuid)
    {
      this.$q.dialog({
        title: this.$t('unsettitle'),
        message: this.$t('unsetmessage'),
        ok: this.$t('yesbtn'),
        cancel: this.$t('nobtn'),
        }).then(() => {
          axios
            .delete(`${this.$root.api_url}device/${uuid}/set_patient/`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + this.$store.state.token
              }
          }).then(() => {
            this.$q.notify({
                message: this.$t('unsetpatientsucc'),
                type: 'positive',
                icon: 'thumb_up'
            })
            this.refresh()
          })
          .catch((e) => {
              // eslint-disable-next-line
              console.log(e.response.data)
              switch (e.response.status) {
                case 403: this.$router.push('/auth'); break
                default: this.$q.notify({message: this.$t('errors.unsetpatienterr'), type: 'negative', icon: 'report_problem' }); break
              }
          })
        }).catch(() => {
        })
      
    },
    
    refresh: function()
    {
      this.request({ pagination: this.serverPagination })
    },

    request ({ pagination }) {
      // console.log(pagination)
      let order = ''
      let offset = 0
      let limit = 1000 
      if (pagination.rowsPerPage != 0)  limit = pagination.rowsPerPage
      offset = (pagination.page - 1) * pagination.rowsPerPage
      if (pagination.sortBy == null) {
        order = 'created'
      } else {
        order = pagination.sortBy
      }
      
      if (!pagination.descending) order = '-' + order
      this.loading = true
      let url = `${this.$root.api_url}device/?ordering=${order}&offset=${offset}&limit=${limit}`
      // console.log(url)
      axios.get(url, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'JWT ' + this.$store.state.token
          }

         }).then(({ data }) => {
          // console.log(data)           
          this.serverPagination = pagination
          this.serverPagination.rowsNumber = data.count
          this.serverData = data.results          
          this.loading = false
        })
        .catch (e =>{
          // eslint-disable-next-line
          console.log(e.response.data)
          switch (e.response.status) {
            case 401: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('error') + ': ' + e.response.statusText, type: 'negative', icon: 'report_problem' }); break
          }
          this.loading = false
        })
      }
  },
    mounted () {
      this.request({ pagination: this.serverPagination })

      // Автоматическое обновление списка каждые 30 секунд
      if (this.refreshid != 0) {
        // eslint-disable-next-line
        console.log('Refresh id is not 0!', this.refreshid)
        clearInterval(this.refreshid)
      } 
      // this.refreshid = setInterval(this.refresh, 10000)
  },

  beforeDestroy() {
    if (this.refreshid != 0) {
      clearInterval(this.refreshid)
      this.refreshid = 0
    }
  },

  components: { settingsDlg, selectPatientDlg, logDlg }

}
</script>

<style scoped>
  a {
    color:#027be3; /* Цвет обычной ссылки */ 
    text-decoration: underline; /* Добавляем подчеркивание */
   }
   a:visited {
    color: black; /* Цвет посещённой ссылки */
   } 
   a:hover {
    color: #027be3; /* Цвет ссылки при наведении на нее курсора мыши */  
    text-decoration: underline; /* Добавляем подчеркивание */
   }
   .point {
     cursor: pointer;
   }

   .first {
      font-family: 'Courier New', Courier, monospace;
      border-collapse: collapse;
      border-spacing: 0px;
   }
   td.no_border {
      padding:5px;
      border: 0px;
   }

   tr {
      height: 10px;
   }

</style>
